var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 91,
    viewBox: "0 0 101 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.79297,
    width: 96.787,
    height: 139.721,
    rx: 8,
    fill: "#1A1A1A",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8594,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#1A1A1A",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.401 49.6966C48.9113 49.6966 52.5676 46.0403 52.5676 41.5299C52.5676 37.0196 48.9113 33.3633 44.401 33.3633C39.8907 33.3633 36.2344 37.0196 36.2344 41.5299C36.2344 46.0403 39.8907 49.6966 44.401 49.6966Z",
    fill: "#1A1A1A",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4067 66.824C78.2705 66.264 78.0253 65.6107 77.7529 64.9107V64.8407C75.5192 59.0074 73.2037 54.434 70.8337 51.284C69.6351 49.7207 68.3821 48.4374 67.02 47.5507C65.6307 46.664 64.0508 46.104 62.3346 46.244C57.2678 46.594 53.8355 50.164 51.411 52.8707C51.0841 53.244 50.7573 53.6174 50.4576 53.944C49.5587 54.9474 48.7959 55.834 48.0332 56.534C46.9708 57.514 46.3987 57.6774 46.1536 57.6774C45.636 57.6774 45.0367 57.5374 44.1922 57.164C43.4568 56.8374 42.6941 56.394 41.7952 55.904C41.6862 55.834 41.55 55.764 41.441 55.694C39.4797 54.5974 36.8646 53.1274 33.7046 53.1274C32.0429 53.1274 30.5992 53.7574 29.4278 54.574C28.2837 55.3907 27.303 56.4874 26.4586 57.6307C24.7696 59.9174 23.4621 62.764 22.5631 65.0507V65.1207C22.2907 65.7507 22.0456 66.3574 21.9094 66.8707C21.7459 67.454 21.6914 68.084 21.9094 68.784C22.1818 69.764 22.9718 70.6974 23.9797 71.234C24.6879 71.6307 25.4507 71.7707 26.1589 71.8174C26.8127 71.864 27.5755 71.864 28.4199 71.864H71.7872C72.6861 71.864 73.5033 71.864 74.1844 71.8174C74.8926 71.7707 75.6826 71.6307 76.4181 71.234C77.426 70.674 78.1888 69.7874 78.4884 68.8074C78.7063 68.084 78.5974 67.4307 78.4612 66.824H78.4067Z",
    fill: "#1A1A1A",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerNotification);
export default __webpack_public_path__ + "static/media/banner-notification.91037d249adc40a6b09f524c3dc365af.svg";
export { ForwardRef as ReactComponent };